<template>
  <div>
    <v-list
      dense
      :class="$style.v_list"
    >
      <v-list-item
        style="padding: 0;"
        v-for="item in last_notifs.length ? last_notifs : last_news"
        :key="item.id"
      >
        <div :class="$style.messageBoxList">
          <div :class="$style.messageBox">
            <div :class="$style.decor">
              <div class="d-flex">
                <div
                  v-if="!item.is_read"
                  :class="$style.indicator"
                  color="red darken-3"
                />

                <span
                  class="title font-weight-regular"
                  :class="$style.messageDate"
                >
                  {{ item.date | date }} {{ item.time }}
                </span>
              </div>

              <span
                v-if="!item.is_read"
                :class="$style.not_read"
                class="title font-weight-regular"
                @click="reading_notification(item.id)"
              >
                Прочитать
              </span>

              <span
                v-else
                :class="$style.is_read"
                class="title font-weight-regular"
              >
                <v-icon
                  small
                  class="mb-1"
                >
                  mdi-check
                </v-icon>

                Прочитано
              </span>
            </div>

            <span
              :class="!item.is_read ? $style.messageText : $style.messageTextNotRead"
              @click="go_to_notification_detail(item)"
            >
              {{ item.title }}
            </span>
          </div>
        </div>
      </v-list-item>
    </v-list>

    <router-link
      v-if="tab_model === 'news'"
      :to="go_to_news"
      :class="$style.notificationsAllLink"
    >
      <p>Все новости</p>
    </router-link>
  </div>
</template>

<script lang="ts">
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { notifications_store, widgets_store } from '@/store';
import { Notifications } from '@/modules/notifications/types';
import { Tabs } from '@/components/global';
import GetRouteSlugMixin from '@/modules/notifications/mixins/get_route_slug';
import { News } from '@/modules/news/types';

const { actions } = notifications_store;

@Component({
  components: {
    Tabs,
  },
})
export default class NotificationsTab extends Mixins(GetRouteSlugMixin) {
  @Prop({ type: Array, default: () => ([]) })
  last_notifs!: Notifications.Notification[];

  @Prop({ type: Array, default: () => ([]) })
  last_news!: Notifications.Notification[];

  destroyed() {
    widgets_store.mutations.CLEAR_TAB_MODEL();
  }

  get tab_model() {
    return widgets_store.state.notification_widget_tab_model === 0 ? 'info' : 'news';
  }

  async reading_notification(id: number) {
    const arrayID = [id];

    await actions.reading_notifs(arrayID);
  }

  get go_to_news() {
    return { name: News.Pages.NEWS };
  }
}

</script>

<style module lang="scss">
.v_list {
  padding-top: 0;
}
.messageBoxList {
  padding: 27px 24px;
  border-bottom: solid 1px #ced0d7;
  width: 100%;
}
.messageBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.decor {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 4px;
}
.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: $secondary_darken4;
  margin-top:  2px;
  margin-right: 4px;
}

.messageText {
  font-weight: 700;
  font-size: 14px !important;
  line-height: 20px;
  color: $primary_darken1 !important;
  cursor: pointer;
}

.messageTextNotRead {
  font-size: 14px !important;
  line-height: 20px;
  color: $primary_darken1 !important;
  cursor: pointer;
}

.not_read {
  font-size: 14px;
  opacity: 0.7;
  color: rgb(0, 155, 211);
  text-decoration: underline;
  cursor: pointer;
}

.is_read {
  font-size: 14px;
  opacity: 0.7;
  color: rgb(166, 166, 166);
}

.notificationsAllLink {
  display: flex;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: -16px;
  p {
    margin-top: 16px;
  }
}
</style>
